import type { StoreLogMessageBody } from '@tapp/api';
import { storeLogMessage } from '@tapp/api/fetch';

/**
 * Sends telemetry data to the backend which can then be used to create reports and insights
 * in OpenSearch.
 */
export function useTelemetry({ message, metadata }: StoreLogMessageBody) {
  const config = useRuntimeConfig();

  if (!message) {
    return;
  }

  if (config.public.STAGE === 'production') {
    return storeLogMessage('frontend', { message, metadata });
  } else if (config.public.STAGE === 'development') {
    console.info(`Telemetry: ${message}`, metadata);
  }
}
